import coordDatum from '../coordDatum/coordDatum.js';

/**
 * 从地图链接解析 API 结果中选取用于填表的坐标（优先 WGS84）
 * 行为与原 CoordinateTool.handleMapUrlParse 一致。
 */
export function pickFillCoordinatesFromMapUrlResult(data) {
  const c = data.coordinates || {};
  const all = data.allCoordinates || {};
  let coordinates = c.wgs84 || all.wgs84 || null;
  if (!coordinates && data.system === 'WGS84' && c.lat != null && c.lng != null) {
    coordinates = { lat: c.lat, lng: c.lng };
  } else if (!coordinates && data.system === 'GCJ02' && c.gcj02) {
    coordinates = c.gcj02;
  } else if (!coordinates && (c.lat != null && c.lng != null)) {
    coordinates = { lat: c.lat, lng: c.lng };
  }
  return coordinates;
}

/**
 * 从地图链接解析结果中选取 Mapbox 落点坐标（优先 WGS84）
 * 行为与原 CoordinateTool mapUrlResult effect 一致。
 */
export function pickMapMarkerCoordinatesFromMapUrlResult(mapUrlResult) {
  let coordinates = null;

  if (mapUrlResult.coordinates.wgs84) {
    coordinates = mapUrlResult.coordinates.wgs84;
    console.log('使用WGS84坐标:', coordinates);
  } else if (mapUrlResult.system === 'WGS84') {
    coordinates = mapUrlResult.coordinates;
    console.log('使用系统WGS84坐标:', coordinates);
  } else if (mapUrlResult.coordinates.gcj02) {
    coordinates = mapUrlResult.coordinates.gcj02;
    console.log('使用GCJ02坐标（需要后端转换）:', coordinates);
  } else if (mapUrlResult.coordinates.bd09) {
    coordinates = mapUrlResult.coordinates.bd09;
    console.log('使用BD09坐标（需要后端转换）:', coordinates);
  } else {
    coordinates = mapUrlResult.coordinates;
    console.log('使用默认坐标:', coordinates);
  }

  return coordinates;
}

/**
 * 预览地图（Mapbox，WGS84）落点：把某坐标系下的点换成 WGS84 再画，才会落在正确地物上。
 * 换算失败（坐标系未知/非法数值）时原样返回。
 * @param {{lng:number|string, lat:number|string}} point
 * @param {string} system WGS84 / GCJ02 / BD09 / CGCS2000
 */
export function toWgs84ForPreview(point, system) {
  if (!point) return point;
  const wgs = coordDatum.convertLngLat(point.lng, point.lat, system, coordDatum.DATUM.WGS84);
  return wgs || point;
}

/**
 * 地图链接解析结果 → 预览地图（WGS84）落点。
 * 与 pickMapMarkerCoordinatesFromMapUrlResult 选点顺序相同；只有 GCJ02/BD09 坐标时换成 WGS84。
 */
export function pickMapMarkerWgs84FromMapUrlResult(mapUrlResult) {
  const c = mapUrlResult && mapUrlResult.coordinates;
  if (!c) return null;
  if (c.wgs84) return c.wgs84;
  if (mapUrlResult.system === 'WGS84') return c;
  if (c.gcj02) return toWgs84ForPreview(c.gcj02, coordDatum.DATUM.GCJ02);
  if (c.bd09) return toWgs84ForPreview(c.bd09, coordDatum.DATUM.BD09);
  const sys = coordDatum.normalizeDatum(mapUrlResult.system);
  if (sys && sys !== coordDatum.DATUM.WGS84) return toWgs84ForPreview(c, sys);
  return c;
}
